import { Show } from "react-admin";

const ShowContainer = Show;

export default ShowContainer;

export interface ShowContainerProps {}
